module.exports = __webpack_public_path__ + "media/assets/icons/friends-39479c0e38511fdb1d0ab651c1661068.svg";